import apiClient from './apiClient';
import { isTenantContext } from '../utils/tenant';

const STORAGE_KEY = 'kss_tenant_branding';

/**
 * Fetch branding from the API.
 * Returns null immediately for non-tenant subdomains (devapp, testapp, app, bare domain)
 * so the caller falls back to the default logo without making a network request.
 */
export const fetchBranding = () => {
    if (!isTenantContext()) return Promise.resolve(null);
    return apiClient.get('/authenticate/branding');
};

export function storeBranding(data) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
        // ignore storage errors
    }
}

export function getCachedBranding() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_) {
        return null;
    }
}

export function clearBranding() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // ignore storage errors
    }
}
